import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Subject_Service {

//   nadraVerificationSubject = new Subject();
//   existingApplicationDataSubject = new Subject();
//   getApplicationSubject = new Subject();
    appDataLoading = new Subject();
//   sideBarMenu = new Subject();
    tabReloadEvent = new Subject();
    applicationId = new Subject();
    grants_application_id = new Subject()
    spRoles = new Subject();
//   tabSavedEvent = new Subject();
//   senduserEmailEvent = new Subject();
    tabSelectedEvent = new Subject()

  constructor() {
  }
}
